export const saveConsultingData = `mutation SaveConsultingData($consultingData: SaveConsultingData) {
    saveConsultingData(data: $consultingData)
  }`;
